import { extend } from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';

export default function () {
  // extend(UserCard.prototype, 'view', function (vnode) {});

  extend(UserCard.prototype, 'infoItems', function (items) {
    if (items.has('badges')) {
      items.setPriority('badges', -50);
    }
    if (items.has('lastSeen') || items.has('joined')) {
      items.add(
        'lastSeenAndJoined',
        <div>
          {items.has('lastSeen') && items.get('lastSeen')}
          {items.has('joined') && items.get('joined')}
        </div>,
        100
      );
      items.remove('lastSeen');
      items.remove('joined');
    }
  });
}
